import { render } from "./icon-face-0.svg?vue&type=template&id=03935e1b"
const script = {}

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__